export const REGION_STORAGE_KEY = 'adapt-mh.current_region';

export const AVAILABLE_REGIONS = ['Region A', 'Region B', 'Region C'] as const;

export type SupportedRegion = (typeof AVAILABLE_REGIONS)[number];
export const AVAILABLE_LOCALITIES = ['Urban', 'Rural'] as const;
export type SupportedLocality = (typeof AVAILABLE_LOCALITIES)[number];

export const DEFAULT_REGION: SupportedRegion = 'Region A';
export const DEFAULT_LOCALITY: SupportedLocality = 'Urban';

export interface RegionalProfile {
  country: SupportedRegion;
  locality: SupportedLocality;
}

export const DEFAULT_REGIONAL_PROFILE: RegionalProfile = {
  country: DEFAULT_REGION,
  locality: DEFAULT_LOCALITY,
};

const isSupportedRegion = (value: string): value is SupportedRegion => {
  return AVAILABLE_REGIONS.includes(value as SupportedRegion);
};

const isSupportedLocality = (value: string): value is SupportedLocality => {
  return AVAILABLE_LOCALITIES.includes(value as SupportedLocality);
};

export const serializeRegionalProfile = (profile: RegionalProfile): string => {
  return JSON.stringify(profile);
};

// Supports both legacy string values and new JSON object values.
export const parseRegionalProfile = (
  rawValue: false | string | null | undefined,
): RegionalProfile => {
  if (typeof rawValue !== 'string' || rawValue.length === 0) {
    return DEFAULT_REGIONAL_PROFILE;
  }

  if (isSupportedRegion(rawValue)) {
    return {
      country: rawValue,
      locality: DEFAULT_LOCALITY,
    };
  }

  try {
    const parsed = JSON.parse(rawValue) as Partial<RegionalProfile>;
    const country = typeof parsed.country === 'string' ? parsed.country : '';
    const locality = typeof parsed.locality === 'string' ? parsed.locality : '';

    if (!isSupportedRegion(country)) {
      return DEFAULT_REGIONAL_PROFILE;
    }

    if (!isSupportedLocality(locality)) {
      return {
        country,
        locality: DEFAULT_LOCALITY,
      };
    }

    return {
      country,
      locality,
    };
  } catch {
    return DEFAULT_REGIONAL_PROFILE;
  }
};
